import * as yup from 'yup';
import { i18n } from '@shared/i18n';
import GenericField from '@shared/fields/generic-field';

export default class BooleanField extends GenericField {
  constructor(
    name,
    label,
    {
      yesLabel = undefined,
      noLabel = undefined,
      mandatoryTrue = false,
      required = false,
      mandatoryErrorCaption = false,
      linkCaptionPrivacy = null,
      linkHrefPrivacy = null,
      linkCaptionTerms = null,
      linkHrefTerms = null,
    } = {},
  ) {
    super(name, label);

    this.mandatoryTrue = mandatoryTrue;
    this.required = required;
    
    this.yesLabel = yesLabel || i18n('common.yes');
    this.noLabel = noLabel || i18n('common.no');

    this.options = [
      { id: true, label: this.yesLabel },
      { id: false, label: this.noLabel },
    ]
    
    this.linkCaptionPrivacy = linkCaptionPrivacy;
    this.linkHrefPrivacy = linkHrefPrivacy;
    this.linkCaptionTerms = linkCaptionTerms;
    this.linkHrefTerms = linkHrefTerms;
    this.mandatoryErrorCaption = mandatoryErrorCaption;

    if (this.linkCaptionPrivacy && this.linkHrefPrivacy && this.linkCaptionTerms && this.linkHrefTerms) {
      const linkPrivacy = `<a href="${this.linkHrefPrivacy}" target="_blank" class="el-link el-link--primary is-underline">${this.linkCaptionPrivacy}</a>`;
      const linkTerms = `<a href="${this.linkHrefTerms}" target="_blank" class="el-link el-link--primary is-underline">${this.linkCaptionTerms}</a>`;
      this.label = label.replace('${linkPrivacy}', linkPrivacy);
      this.label = this.label.replace('${linkTerms}', linkTerms);
    } else {
      this.label = label;
    }
  }

  forPresenter(value) {
    return value ? this.yesLabel : this.noLabel;
  }

  forFilterInitialValue(value) {
    return value;
  }

  forFormInitialValue(value) {
    // if (!value) return false;
    return value;
  }

  forFormRules() {
    const output = [];

    if (this.mandatoryTrue) {
      output.push({
        validator: (rule, value, callback) => {
          const errorMessage = this.mandatoryErrorCaption || i18n('validation.mixed.requiredLabel').replace('${path}', this.label);
          if (!value) callback(new Error(errorMessage));
          else callback();
        }
      });
    }


    if (this.required) {
      output.push({
        required: !!this.required,
        message: i18n('validation.mixed.required').replace(
          '${path}',
          this.label,
        ),
      });
    }
    return output;
  }

  forFormCast() {
    let yupChain = yup
      .bool()
      .nullable(false)
      .default(false)
      .label(this.label);
    return yupChain;
  }

  forFilterRules() {
    return undefined;
  }

  forFilterCast() {
    let yupChain = yup.bool().label(this.label);
    return yupChain;
  }

  forExport() {
    return yup
      .bool()
      .nullable(true)
      .default(false)
      .label(this.label);
  }

  forImport() {
    let yupChain = yup
      .bool()
      .default(false)
      .label(this.label);
    return yupChain;
  }
}
